module.exports = __webpack_public_path__ + "static/media/head.109c4c00.gif";